<template>
	<label :for="value.id">
		<input type="radio" name="anos" :id="value.id" :checked="checked"  @change="checkStatusChange"  />
		<span class="box">
			<i class="fas fa-check"></i>
		</span>
		<span class="text">{{ value.label }}</span>
	</label>
</template>

<script>
export default {
	name: 'Radio',
	props: {
		checked: {
			default: false
		},
		value: {
			type: Object
		}
	},
	methods: {
		checkStatusChange (value) {
			this.$emit('change', value)
		}
	}
}
</script>

<style lang="scss" scoped>
label {
	display: flex;
	align-items: center;
	cursor: pointer;
	font-weight: 400;
	font-size: 1em;

	&:not(:last-of-type) {
		margin-bottom: 14px;
	}

	input[type=radio] {
		display: none;

		&:checked + span.box {
			background-color: $success-color;
		}

		&:checked + span.box i {
			opacity: 1;
		}
	}

	.box {
		width: 26px;
		height: 26px;
		border-radius: 13px;
		background-color: #fff;
		transition: background 300ms ease;
		border: 1px solid $main-color;
		display: flex;
		align-items: center;
		justify-content: center;

		i {
			opacity: 0;
			color: #fff;
			transition: opacity 300ms ease-in;
		}

		&:hover {
			background-color: $success-color;
		}
	}

	.text {
		margin-left: 14px;
	}
}
</style>
